import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import Button from "@material-ui/core/Button/Button";
import Slide from "@material-ui/core/Slide/Slide";

const Transition = (props) => {
  return <Slide direction="up" {...props} />;
};

const styles = (theme) => ({
  closeBtn: {
    color: theme.palette.primary.main,
    float: "right",
    marginRight: "-6%",
    fontWeight: 500,
  },
  dialogContent: {
    color: theme.palette.common.black,
  },
});

/*
   Dialog to display the message that minimun investment amount is
   required to proceed the process. Used on Portfolio / Add Client components
*/
const MinimumRequiredDialog = (props) => {
  const { classes, open, onClose, minAmount, message } = props;
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      onClose={onClose}
      aria-labelledby="minimum-initial-investment-dialog-title"
      aria-describedby="minimum-initial-investment-dialog-description"
    >
      <DialogTitle id="minimum-initial-investment-dialog-title">
        Minimum Investment Required
        <Button className={classes.closeBtn} onClick={onClose}>
          X
        </Button>
      </DialogTitle>
      <DialogContent>
        {minAmount !== "" && (
          <DialogContentText
            id="minimum-initial-investment-dialog-description"
            className={classes.dialogContent}
          >
            The minimum account is <em>{minAmount}</em>.
          </DialogContentText>
        )}
        {message !== "" && (
          <DialogContentText
            id="minimum-initial-investment-dialog-description"
            className={classes.dialogContent}
          >
            {message}
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={onClose}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

MinimumRequiredDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  minAmount: PropTypes.string,
  message: PropTypes.string,
};

export default withStyles(styles, { withTheme: true })(MinimumRequiredDialog);



// WEBPACK FOOTER //
// ./src/components/UI/MinimumRequiredDialog.jsx